var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _rect, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntermittentFasting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 269,
    height: 146,
    viewBox: "0 0 269 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118 138C93.6995 138 74 118.301 74 94C74 69.6995 93.6995 50 118 50C142.301 50 162 69.6995 162 94C162 118.301 142.301 138 118 138Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154 146C129.699 146 110 126.301 110 102C110 77.6995 129.699 58 154 58C178.301 58 198 77.6995 198 102C198 126.301 178.301 146 154 146Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113 110C86.4903 110 65 88.5097 65 62C65 35.4903 86.4903 14 113 14C139.51 14 161 35.4903 161 62C161 88.5097 139.51 110 113 110Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M172 126C145.49 126 124 104.51 124 78C124 51.4903 145.49 30 172 30C198.51 30 220 51.4903 220 78C220 104.51 198.51 126 172 126Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M149 104C120.281 104 97 80.7188 97 52C97 23.2812 120.281 0 149 0C177.719 0 201 23.2812 201 52C201 80.7188 177.719 104 149 104Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(-1 0 0 1 266 52)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-1 0 0 1 61 131)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 3 64)",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 63 2)",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 216 0)",
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 269 135)",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 22,
    width: 104,
    height: 104,
    rx: 52,
    fill: "#F74A4A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M112.009 57.3223L121.908 67.2218C125.032 70.346 130.098 70.346 133.222 67.2218V67.2218C136.346 64.0976 136.346 59.0322 133.222 55.9081L123.322 46.0086",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M120.494 65.8076V65.8076C122.837 68.1508 126.636 68.1508 128.979 65.8076L131.808 62.9792C134.151 60.636 134.151 56.8371 131.808 54.4939V54.4939",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M133.222 67.2214L117.666 51.665",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M131.525 68.9184L134.919 65.5243L158.678 87.0204L164.335 92.6772C165.897 94.2393 165.897 96.772 164.335 98.3341C162.773 99.8962 160.24 99.8962 158.678 98.3341L153.021 92.6772L131.525 68.9184Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M160.622 68.5203C156.815 72.3279 150.562 72.2488 146.657 68.3435C142.752 64.4383 142.673 58.1858 146.48 54.3782C150.288 50.5706 159.149 44.0662 165.042 49.9588C170.934 55.8513 164.43 64.7127 160.622 68.5203Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M146.375 65.232L149.769 68.6261L128.273 92.3849L122.616 98.0417C121.054 99.6038 118.521 99.6038 116.959 98.0417C115.397 96.4796 115.397 93.947 116.959 92.3849L122.616 86.728L146.375 65.232Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M223 25L241.5 19.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M231 104L249 108.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26 27.5L43.5 32",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 107.5L30 114",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntermittentFasting);
export default __webpack_public_path__ + "static/media/intermittent-fasting.e765576d1b33645b3600cfb76c8448c0.svg";
export { ForwardRef as ReactComponent };